import React from "react";
import { ComponentDetailPageInitialState, PageNewState } from "./";

export const ComponentDetailPageContext = React.createContext({
  pageState: ComponentDetailPageInitialState,
  setPageState: (pageState: PageNewState) => {},
});
